<div *ngIf="isOpen" class="modal-bg">

    <div class="modal-card">
        <h5>User Details: </h5>
        <div *ngIf="!isLoading" class="details-container">

            <div class="row-div">
                <div class="details-div">
                    <label for="">Username:</label>
                    <input class="username" type="text" [value]="userDetails.username ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Email:</label>
                    <input type="text" [value]="userDetails.email ?? 'N/A'" disabled>
                </div>
            </div>

            <div class="row-div">
                <div class="details-div">
                    <label for="">First Name:</label>
                    <input type="text" [value]="userDetails.firstname ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Middle Name:</label>
                    <input type="text" [value]="userDetails.middlename ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Last Name:</label>
                    <input type="text" [value]="userDetails.lastname ?? 'N/A'" disabled>
                </div>
            </div>
            <div class="row-div">
                <div class="details-div">
                    <label for="">Company:</label>
                    <input type="text" [value]="userDetails.company ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                </div>
            </div>
            <div class="row-div">
                <div class="details-div">
                    <label for="">Mobile No.:</label>
                    <input type="text" [value]="userDetails.mobileNo ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Source Wallet:</label>
                    <input type="text" [value]="userDetails.source_wallet ?? 'N/A'" disabled>
                </div>
            </div>
            <div class="row-div">
                <div class="details-div">
                    <label for="">City:</label>
                    <input type="text" [value]="userDetails.city_name ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">Province:</label>
                    <input type="text" [value]="userDetails.province ?? 'N/A'" disabled>
                </div>
            </div>
            <div class="row-div">
                <div class="details-div">
                    <label for="">Address:</label>
                    <input type="text" [value]="userDetails.address ?? 'N/A'" disabled>
                </div>
            </div>
            <div class="row-div">
                <div class="details-div">
                    <label for="">Address 2:</label>
                    <input type="text" [value]="userDetails.address_2 ?? 'N/A'" disabled>
                </div>
            </div>
            <div class="row-div">
                <div class="details-div">
                    <label for="">Level:</label>
                    <input type="text" [value]="userDetails.level ?? 'N/A'" disabled>
                </div>
                <div class="details-div">
                    <label for="">userLevel:</label>
                    <input type="text" [value]="userDetails.userLevel ? globalservice.userLevelTransition(userDetails.userLevel) : 'N/A'" disabled>
                </div>
            </div>
            
        </div>
        
        <div *ngIf="isLoading" class="table-spinner-div">
            <span class="sr-only"> <div class="spinner-border" role="status"> </div> Loading...</span>
        </div>

        <button (click)="closeModal()" class="close-button"> Close </button>
    </div>

</div>